module.exports = __webpack_public_path__ + "img/edit-profile-card.6637df54.png";